<div class="modal-header pb-2 pt-2">
  <div
    [class.text-danger]="type === 'error'"
    [class.text-warning]="type === 'warning'"
    [class.text-info]="type === 'info'"
  >
    <i class="fa"
       [class.fa-remove]="type === 'error'"
       [class.fa-warning]="type === 'warning'"
       [class.fa-info-circle]="type === 'info'"
    ></i>
    {{title}}
  </div>
  <div class="pull-right">
    <a href="javascript: void(0)" (click)="modal.dismiss()">&times;</a>
  </div>
</div>
<div class="modal-body pb-2 pt-2">
  <div [innerHTML]="message"></div>
</div>
